export const FORM_NAME = 'NEXT_STEPS_SIDEBAR_FORM';
